// extracted by mini-css-extract-plugin
export default {"grid":"styles_grid__0c7iK","desktop":"styles_desktop__VuUG+","flex":"styles_flex__CE0RQ","type":"styles_type__Adg6m"};